import { environment } from '../environments/environment'

export const PATH = environment.PATH
export const ENVIRONMENT = environment.ENV
export const GOOGLE_API_KEY = environment.GOOGLE_API_KEY
